import { WtpData } from './wtp-data';

export class WtpCountrySingleType {
  isoCode: string;
  name: string;
  wtpData: WtpData;
}
